import { ipValidationSchema } from 'constants/schemas';
import IpFormatSelect from '../../components/select/IpFormatSelect';
import IpVersionSelect from '../../components/select/IpVersionSelect';
import { InputField } from '../../types';
import { CUSTOM } from '../index';

const ipVersionFields: InputField[] = [
  {
    addLabel: 'Add IP range',
    fields: [
      {
        component: IpFormatSelect,
        label: 'ipVersion.formLabels.format',
        name: 'format',
        type: CUSTOM,
        width: {
          desktop: 6,
        },
      },
      {
        component: IpVersionSelect,
        label: 'ipVersion.formLabels.ipVersion',
        name: 'ipVersion',
        type: CUSTOM,
        width: {
          desktop: 6,
        },
      },
      {
        label: 'ipVersion.formLabels.ipAddresses',
        name: 'ipAddresses',
        type: 'text',
        width: {
          desktop: 6,
        },
      },
      {
        label: 'ipVersion.formLabels.description',
        name: 'description',
        type: 'text',
        width: {
          desktop: 6,
        },
      },
    ],
    initialValue: null,
    name: 'ipRanges',
    removeLabel: 'Remove IP range',
    type: 'array',
    width: {
      desktop: 12,
    },
  },
];

const ipVersionValidationSchema = ipValidationSchema;

const headerTranslations = {
  content: 'ipVersion.content',
  title: 'ipVersion.title',
};

export const ipv4Step = {
  fields: ipVersionFields,
  headerTranslations,
  key: 'ipRanges',
  validationSchema: ipVersionValidationSchema,
};
